import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { apiSlice } from "../slices/apiSlice";
import authSlice from "../slices/authSlice/authSlice";
import forgotSlice from "../slices/forgotSlice/forgotSlice";
import passwordSlice from "../slices/passwordSlice/passwordSlice";
import menuSlice from "../slices/MenuSlice/menuSlice";
import trackingSlice from "../slices/trackingSlice/trackingSlice";
import { dataTrackingSlice } from "../slices/trackingSlice/trackingApiSlice";
import { menuApliSlice } from "../slices/MenuSlice/menuApliSlice";
import consultSlice from "../slices/consultSlice/consultSlice";
import exportExcSlice from "../slices/exportExcSlice/exportExcSlice";
import usuariosSlice from "../slices/Paramgen/Usuarios/usuariosSlice";
import errorsSlice from "../slices/Errorsxx/errorsSlice";
import confirmSlice from "../slices/Confirmx/confirmSlice";
import providerSlice from "../slices/Pfinanci/Provider/providerSlice";
import ofercomeSlice from "../slices/Financix/ofercomeSlice";
import fichacliSlice from "../slices/Modclixx/Fichacli/fichacliSlice";
import fichprovSlice from "../slices/Modclixx/Fichprov/fichprovSlice";
import ficinkpivSlice from "../slices/Indicaxx/Ficinkpi/ficinkpivSlice";

//Redux persist
import storageSession from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";

import { thunk } from "redux-thunk";
import centcostSlice from "../slices/Pfinanci/Centcost/centcostSlice";
import anticipoSlice from "../slices/Modimpxx/Anticipo/anticipoSlice";
import genioxxxSlice from "../slices/Genioxxx/genioxxxSlice";
import { genioxxxApiSlice } from "../slices/Genioxxx/genioxxxApiSlice";
import { autocomxxApiSlice } from "../slices/Autocomxx/autocomxxApiSlice";
import notificxSlice from "../slices/NotificxSlice/notificxSlice";
import graficsxSlice from "../slices/Graficsx/graficsxSlice";
import saldoctrSlice from "../slices/Doctraxx/Saldoctr/saldoctrSlice";
import tareasxxSlice from "../slices/Ordtraxx/Tareasxx/tareasxxSlice";
import trackimpSlice from "../slices/Modimpxx/Trackimp/trackimpSlice";
import trackcrlSlice from "../slices/Modimpxx/Trackcrl/trackcrlSlice";
import reslegxxSlice from "../slices/Paraduax/Reslegxx/reslegxxSlice";
import producxxSlice from "../slices/Producxx/producxxSlice";
import busapixxSlice from "../slices/Busapixx/busapixxSlice";
import { busapixxApiSlice } from "../slices/Busapixx/busapixxApiSlice";
import { webSlice } from "../slices/webSlice";
import resdocuxSlice from "../slices/Modimpxx/Resdocux/resdocuxSlice";
import tracscrlSlice from "../slices/Tracscrl/tracscrlSlice";
import doclientSlice from "../slices/Modclixx/Doclient/doclientSlice";
import dosptefaSlice from "../slices/Financix/Dosptefa/dosptefaSlice";
import floatoolSlice from "../slices/Floatool/floatoolSlice";
import producvuSlice from "../slices/Registxx/Documexx/Producvu/producvuSlice";
import autorizaSlice from "../slices/Autoriza/Generals/generalsSlice";
import criticidSlice from "../slices/Graficsx/Criticid/criticidSlice";
import admindocSlice from "../slices/Admindoc/admindocSlice";
import mipuestoSlice from "../slices/Mipuesto/mipuestoSlice";

const persistConfig = {
  key: "auth",
  storage: storageSession,
};

const graphPersistConfig = {
  key: "graph",
  storage: storageSession,
};
const persistedReducer = persistReducer(persistConfig, authSlice);

const graphPersistReducer = persistReducer(graphPersistConfig, graficsxSlice);

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    [genioxxxApiSlice.reducerPath]: genioxxxApiSlice.reducer,
    [autocomxxApiSlice.reducerPath]: autocomxxApiSlice.reducer,
    [busapixxApiSlice.reducerPath]: busapixxApiSlice.reducer,
    [webSlice.reducerPath]: webSlice.reducer,
    persistedReducer,
    graphPersistReducer,
    forgot: forgotSlice,
    password: passwordSlice,
    menu: menuSlice,
    tracking: trackingSlice,
    consult: consultSlice,
    exportexcl: exportExcSlice,
    usuarios: usuariosSlice,
    errors: errorsSlice,
    confirm: confirmSlice,
    provider: providerSlice,
    ofercome: ofercomeSlice,
    fichacli: fichacliSlice,
    fichprov: fichprovSlice,
    centcost: centcostSlice,
    anticipo: anticipoSlice,
    genioxxx: genioxxxSlice,
    notificx: notificxSlice,
    saldoctr: saldoctrSlice,
    tareasxx: tareasxxSlice,
    trackimp: trackimpSlice,
    trackcrl: trackcrlSlice,
    ficinkpi: ficinkpivSlice,
    reslegxx: reslegxxSlice,
    producxx: producxxSlice,
    busapixx: busapixxSlice,
    resdocux: resdocuxSlice,
    tracscrl: tracscrlSlice,
    doclient: doclientSlice,
    dosptefa: dosptefaSlice,
    floatool: floatoolSlice,
    producvu: producvuSlice,
    autoriza: autorizaSlice,
    criticid: criticidSlice,
    admindoc: admindocSlice,
    mipuesto: mipuestoSlice,
  },
  devTools: process.env.REACT_APP_CIMA_DEBUG,
  middleware: [
    thunk,
    dataTrackingSlice.middleware,
    menuApliSlice.middleware,
    genioxxxApiSlice.middleware,
    autocomxxApiSlice.middleware,
    busapixxApiSlice.middleware,
    webSlice.middleware,
  ],
});

export const persistor = persistStore(store);

// Habilita refetchOnFocus / refetchOnReconnect en las queries (el tracking
// se refresca al volver a la pestaña — Diego 2026-08-19, #377)
setupListeners(store.dispatch);
